var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{staticClass:"product-video",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"type":_vm.mimeType}}),_vm._v("\n  "+_vm._s(_vm.unsupportedVideoMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }